import { render, staticRenderFns } from "./OrderSingleShipmentItems.vue?vue&type=template&id=2dfe1628&"
import script from "./OrderSingleShipmentItems.vue?vue&type=script&lang=js&"
export * from "./OrderSingleShipmentItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports